import React, { useState } from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import videos from "../../locales/videos.json"
import Gallery from "../components/gallery"
import VideoGallery from "../components/videoGallery"
import { useTranslation } from "react-i18next"
import Seo from "../components/seo"

const MediaPage = ({ data }) => {
  const { t } = useTranslation()

  const [activePanel, setActivePanel] = useState("pictures")

  return (
    <Layout page="gallery">
      <Seo title="Media" />
      <div className="subMenu">
        <ul className="menu-nav">
          <button
            onClick={() => setActivePanel("pictures")}
            className={activePanel === "pictures" ? "selected" : undefined}
          >
            {t("Photos")}
          </button>

          <button
            onClick={() => setActivePanel("videos")}
            className={activePanel === "videos" ? "selected" : undefined}
          >
            {t("Videos")}
          </button>
        </ul>
      </div>
      <div className="gallery_container">
        {activePanel === "pictures" && <Gallery pictures={data.pictures} />}
        {activePanel === "videos" && <VideoGallery videos={videos.videoList} />}
      </div>
    </Layout>
  )
}

export default MediaPage

export const query = graphql`
  query Gallery($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    pictures: allFile(filter: { relativeDirectory: { eq: "gallery" } }) {
      nodes {
        id
        name
        childImageSharp {
          gatsbyImageData(
            layout: CONSTRAINED
            # width: 1000
            # height: 900
            # blurredOptions: { width: 10 }
            placeholder: DOMINANT_COLOR
          )
          fixed {
            aspectRatio
          }
        }
      }
    }
  }
`
